import WifiEnabledInstructions from './WifiEnabledInstructions';

export default WifiEnabledInstructions;
